import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const AndersMichelsen = (props) => {
  const data = useStaticQuery(graphql`
    query {
      file(
        relativePath: {
          eq: "components/pages/AboutPage/Sections/TeamSection/images/anders-michelsen.jpg"
        }
      ) {
        childImageSharp {
          fixed(width: 92, height: 92, quality: 100, cropFocus: NORTH) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return <Img fixed={data.file.childImageSharp.fixed} {...props} />
}

export default AndersMichelsen
